import { useQuery } from "@tanstack/react-query";
import { fetchWholesaleABCRanking, type ABCRankingStore } from "../services/wholesaleABCRanking";

export const useWholesaleABCRanking = (window_size: number) => {
  return useQuery<ABCRankingStore[], Error>({
    queryKey: ["wholesale-abc-ranking", window_size],
    queryFn: () => fetchWholesaleABCRanking(window_size),
    staleTime: 1000 * 60 * 5,
  });
};